export default __webpack_public_path__ + "static/media/login-img.111005d2.png";